import { render, staticRenderFns } from "./AgreementsShow.vue?vue&type=template&id=0e6855a7&"
import script from "./AgreementsShow.vue?vue&type=script&lang=js&"
export * from "./AgreementsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports